<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
      <el-tab-pane :label="item.label" :name="item.key" v-for="item of tabList" :key="item.key"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import uiVariable from '../../config/uiVariable'

export default {
  name: 'K2Tab',
  components: {},
  props: ['onclick', 'tabList'],
  data() {
    return {
      uiVariable: uiVariable,
      activeName: '',
    }
  },
  mounted() {
    this.activeName = this.tabList[0].key
  },
  watch: {
    tabList: function (val) {
      if (val) {
        this.activeName = val[0].key
      }
    },
  },
  methods: {
    handleClick() {
      this.$emit('onclick', this.activeName)
    },
  },
}
</script>
